/** @format */

import { WarrantiesState, WarrantyCallState } from '@pdp/data-access/interfaces';
import { createReducer, on } from '@ngrx/store';
import {
	autoSetSelectedWarranty,
	getAllWarranties,
	getAllWarrantiesError,
	getAllWarrantiesSuccess,
	setSelectedWarranty
} from './warranties.actions';

export const initialWarrantiesState: WarrantiesState = {
	allWarranties: undefined,
	selectedWarranty: undefined,
	warrantyCallState: 'initial'
};

export const warrantiesReducer = createReducer(
	initialWarrantiesState,
	on(getAllWarranties, (state) => ({
		...state,
		warrantyCallState: 'loading' as WarrantyCallState
	})),
	on(getAllWarrantiesSuccess, (state, action) => ({
		...state,
		warrantyCallState: 'success' as WarrantyCallState,
		allWarranties: action.availableWarrantiesResponse?.products
	})),
	on(getAllWarrantiesError, (state) => ({
		...state,
		warrantyCallState: 'error' as WarrantyCallState
	})),
	on(setSelectedWarranty, autoSetSelectedWarranty, (state, action) => ({
		...state,
		selectedWarranty: action.selectedWarranty
	}))
);
